import Cookies from 'js-cookie'

const TokenKey = 'accesstoken'

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}

export function setTokenByName(key, value) {
  return Cookies.set(key, value)
}

export function getTokenByName(key) {
  return Cookies.get(key)
}

export function removeByName(key) {
  return Cookies.remove(key)
}

